import { HttpClient } from "@angular/common/http";
import { LoginService } from "./login.service";
import { Router } from "@angular/router";
import { HabilEmpresarialProduto } from "../models/he-produto";
import { AbstractService } from "./abstract.service";
import { Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class HabilEmpresarialProdutoService extends AbstractService<HabilEmpresarialProduto> {
  titulo: string = "HE - Produtos";

  endpoint(): string {
    return "registro/he-produto";
  }
  rotina(): string {
    return "HE_PRODUTOS";
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Nome", field: "nomeProduto" }
    ]
  }
  private uri( ehLista?: boolean ): string {
    let ret = "/adm/he-produtos";
    if ( ehLista ) {
      return 'adm/produtos';
    }
    return ret + "/cadastro";
  }

  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate( [ this.uri() ] )
  }
  abrir(obj: HabilEmpresarialProduto) {
    AbstractService.readonly = true;
    this.router.navigate( [ this.uri() ], { queryParams: {id: obj.id } } );
  }
  edit(obj: HabilEmpresarialProduto) {
    AbstractService.readonly = false;
    this.router.navigate( [ this.uri() ], { queryParams: {id: obj.id } } );
  }
  routeLista() {
    return this.uri( true );
  }

  constructor( public http: HttpClient, public loginService: LoginService, private router: Router ) {
    super( http, loginService );
   }
}
